import React, { Component } from 'react'
import Service from '../service/Service';
const service = new Service();
import * as actions from './actions';

import { Link } from "react-router-dom";
import Cookies from 'js-cookie';

import { fetchInitialData } from "../fetchData";
let local_base_url = "/baby-names";
var backLink = '/';
var collID = '';
class CollectionListAmp extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let collectionList = [];
        this.alphabetsAry = [];
        for (let i = 0; i < 26; i++) {
            this.alphabetsAry.push((i + 10).toString(36));
        }
        // if(global.ftk === ''){
        //     service.showLoader();
        //     service.showAlert("Please Login");
        //     window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        // }

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            if (window.__initialData__['initialData']) {
                collectionList = window.__initialData__['initialData']['FinalResponse'];
            }
            
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                collectionList = props.staticContext.initialData['initialData']['FinalResponse'];
            }
        }
        this.state = {
            initialData: initialData,
            backLink: backLink,
            collectionList: collectionList,
            metaTitle: "My Favourite Baby Names - FirtsCry Parenting",
            metaDescription: [
                { "name": "description", "content": "Find the latest, most popular and unique baby names for your newborn from a list of 100000+ Baby Boy & Girl Names ideas with FirstCry’s Baby Names Finder." },
                { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
                {  "name" : "robots", "content" : "all" }
            ],
            // _backURL: localStorage.getItem('backTothispage')
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {

        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        
        var url = global.api_url + "getmyfavouritelist";
        var body = JSON.stringify({
            "pagesize": size,
            "pageno": 1
        });

        return fetchInitialData(url, JSON.stringify(header), body);
    }
    // componentDidMount(){
        
    //     document.addEventListener("click", actions.domClick);
    //     if (navigator.onLine) {
    //         let size = 10;
    //         if (this.disPageNo > 1) {
    //             size = 10 * this.disPageNo;
    //         }
           
    //         if (this.state.collectionList.length < 1 || this.state.collectionList == "Records Not Found") {
    //             service.showLoader();
                
    //             this.getCollectionList(1, size);
                
    //         }
            
    //     } else {
    //         if (localStorage.getItem('collectionlist')) {
    //             this.setState(
    //                 { collectionList: JSON.parse(localStorage.getItem('collectionlist')) },
    //                 () => { actions.loadSliders(); }
    //             );
    //         }
             
    //         service.showLoader();
    //         setTimeout(function(){
               
    //             service.hideLoader();
    //         }, 500)
    //     }
    //     actions.loadSliders();
    //     //  if (typeof window === 'undefined') {
    //         window.scrollTo(0,0);
    //     // }
    //     this.setState({window_width : window.innerWidth});

    //     this.setState({_backURL : localStorage.getItem('backTothispage')});
    // }

    // componentWillUnmount() {
    //     document.removeEventListener("click", actions.domClick);
    // }

    // getCollectionList(pageno, size) {
    //     var postData = {
    //         "pageSize": size,
    //         "pageNo": pageno
    //     }
    //     var url =  global.api_ci_url + "Babynames/getmyfavouritelist";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['FinalResponse'] != "Records Not Found") {
    //             if (this.state.collectionList.length > 0) {
    //                 if (size == (pageno * 10)) {
    //                     this.setState({ collectionList: json['FinalResponse'] }, () => { service.loadImages(); actions.loadSliders(); });
    //                 } else {
    //                     let ary = this.state.collectionList;
    //                     this.setState({ collectionList: ary.concat(json['FinalResponse']) }, () => { service.loadImages(); actions.loadSliders(); });
    //                 }
    //                 // if (parseInt(pageno) !== 1) {
    //                 //     this.appendURL();
    //                 // }
    //             } else {
    //                 localStorage.setItem('collectionlist', JSON.stringify(json['FinalResponse']));
    //                 this.totalCount = parseInt(json['discussionCount']);
    //                 this.setState({ collectionList: json['FinalResponse'] }, () => { service.loadImages(); actions.loadSliders(); });
    //             }
    //         } else {
    //             document.querySelector(".norecord-overlay").style.display = "block";
    //         }
    //         this.setState({backLink : localStorage.getItem('backTothispage') });
            
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    // updateCollection(elem) {
    //     document.addEventListener("click", actions.domClick);
    //     var collectionName = document.querySelector(".collname_edit").value;
    //     if(/<(.|\n)*?>/g.test(collectionName)){
    //         document.querySelector('.updatelist_error_msg').innerHTML = 'Script tags not allowed';
    //         document.querySelector('.updatelist_error_msg').style.display = "block";
    //         document.querySelector(".collname_edit").value  = '';
    //     }else{
    //         var collectionId = document.querySelector(".collname_edit").getAttribute("data-id");
    //         if (collectionName != '' && collectionName.length <= 100) {
    //             var postData = {
    //                 "collection" : collectionName,
    //                 "collectionId": collectionId,
    //             }
    //             var url =  global.api_ci_url + "Babynames/editcollection";

    //             service.postServiceCall(url, postData).then((json) => {
    //                 document.querySelector(".update-overlay").style.display = "none";
    //                 document.querySelector(".editOptions").style.display = "none";
                        
    //                 if (json['msg'] == 1) {
    //                     document.querySelector(".favouriteNames-overlay").style.display = "block";
    //                     var tempArray = this.state.collectionList;
                        
    //                     setTimeout(function(){

    //                         [].forEach.call(tempArray, function(ele){
    //                             if(ele.coll_id == collectionId){
    //                                 ele.coll_name = collectionName;
    //                             }
    //                         })
    //                         elem.setState({collectionList: tempArray})
    //                     }, 500)

    //                     document.querySelector('.updatelist_error_msg').style.display = "none";
    //                     document.getElementsByTagName('body')[0].style.overflow = "auto";
    //                 } else {
    //                     document.querySelector(".nm-add span").innerHTML = json['result'];
    //                     // $('.name-added').stop().fadeIn(400).delay(1000).fadeOut(400);
    //                     document.querySelector(".name-added").classList += " add_show";
                  
    //                     setTimeout(() => {
    //                         document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
    //                     }, 1000);

    //                 }
    //                 document.querySelector(".collname_edit").value = '';
    //                 document.getElementsByTagName('body')[0].style.overflow = "auto";
                
    //                 service.hideLoader();
    //             }).catch((error) => {
    //                 console.error(error);
    //                 service.hideLoader();
    //             });
    //         } else {
    //             document.querySelector('.updatelist_error_msg').innerHTML = "Max 100 characters are allowed";
    //             document.querySelector('.updatelist_error_msg').style.display = "block";
    //         }
    //     }
    // }
    // cancelUpdate_popup() {
    //     document.querySelector(".favouriteNames-overlay").style.display = "block";
    //     document.querySelector(".update-overlay").style.display = "none";
    //     document.querySelector('.updatelist_error_msg').style.display = "none";
    //     document.querySelector('.editOptions').style.display = "none";
    //     document.getElementsByTagName('body')[0].style.overflow = "auto";
    // }

    // deletecollection(event, elem) {
    //     // service.showLoader();
    //     var collectionId = event.target.getAttribute("data-id");
    //     var postData = {
    //         "collectionId": collectionId,
    //     }
    //     var url =  global.api_ci_url + "Babynames/deletecollection";

    //     service.postServiceCall(url, postData).then((json) => {

    //         if (json['msg'] == 1) {

    //             document.querySelector(".delete-overlay").style.display = "none";
    //             document.querySelector(".favouriteNames-overlay").style.display = "block";
                
    //             document.getElementsByTagName('body')[0].style.overflow = "auto";

    //             var tempArray = this.state.collectionList;
    //             setTimeout(function(){
    //                service.showLoader();
    //                 var finalArray = [];
    //                 [].forEach.call(tempArray, function(ele){
    //                     if(ele.coll_id !== collectionId){
    //                         finalArray.push(ele);
    //                     }
    //                 })
    //                 elem.setState({collectionList: finalArray });
                    
    //                 if(elem.state.collectionList.length == 0){
    //                     document.querySelector(".norecord-overlay").style.display = "block";
    //                 }
    //                 service.hideLoader();
    //             }, 500);
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    // createlistfromCollection() {
    //     document.querySelector('.createnew-collection-overlay').style.display = "block";
    //     document.getElementsByTagName('body')[0].style.overflow = "hidden";
    // }
    // cancelCreate_popup(event){
    //     event.stopPropagation();
    //     // document.querySelector('.collection-list-popup').style.display = "none";
    //     document.querySelector(".createnew-collection-overlay").style.display = "none";
    //     document.querySelector(".input-name").value = '';
    //     document.getElementsByTagName('body')[0].style.overflow = "auto";
    //     document.querySelector(".favlist-block").style.display = "block";

    //     if (document.querySelector(".favNameList").innerHTML == "") {
    //         document.querySelector(".norecord-overlay").style.display = "block";
    //         document.querySelector(".favNameList").style.display = "none";
    //     }
    //     document.querySelector(".error_msg").style.display = "none";
    // }
    // createNewCollection(event) {
    //     var collectionName = event.target.parentElement.parentElement.querySelector(".input-name").value;
    //     if(/<(.|\n)*?>/g.test(collectionName)){
    //         event.target.parentElement.previousSibling.innerHTML = 'Script tags not allowed';
    //         event.target.parentElement.previousSibling.style.display = "block";
    //         event.target.parentElement.parentElement.querySelector(".input-name").value = '';
    //     }else{
    //         if (collectionName.trim() != "" & collectionName.length <= 100) {
    //             var postData = {
    //                 "collection": collectionName,
    //                 "pageSize": 100,
    //                 "pageNo": 1
    //             }
    //             var url =  global.api_ci_url + "Babynames/postcollection";

    //             service.postServiceCall(url, postData).then((json) => {
    //                 if (json['result']) {
    //                     collID = json['result'];

    //                     if (json['msg'] == "1") {
    //                         if(this.state.collectionList == "Records Not Found"){
    //                             this.setState({ collectionList: []})
    //                         }
                            
    //                         this.state.collectionList.push({'coll_id': collID,'coll_name': collectionName,'count': 0});
    //                         this.setState({ collectionList: this.state.collectionList});

    //                         document.querySelector(".norecord-overlay").style.display = "none";
                            
    //                     } else {
    //                         document.querySelector(".nm-add span").innerHTML = collectionName + " already exists";
                            
    //                         document.querySelector(".name-added").classList += " add_show";
                      
    //                         setTimeout(() => {
    //                             document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
    //                         }, 1000);
    //                     }
                        
    //                     document.querySelector(".input-name").value = '';
    //                     // document.querySelector('.collection-list-popup').style.display = "none";
    //                     document.querySelector(".createnew-collection-overlay").style.display = "none";
    //                     document.getElementsByTagName('body')[0].style.overflow = "auto";
    //                     document.querySelector(".favlist-block").style.display = "block";                        
    //                 }
    //                 service.hideLoader();
    //             }).catch((error) => {
    //                 console.error(error);
    //                 service.hideLoader();
    //             });
               
    //         } else {
    //             event.target.parentElement.previousSibling.innerHTML = "Max 100 characters are allowed";
    //             event.target.parentElement.previousSibling.style.display = "block";
    //             event.target.parentElement.parentElement.querySelector(".input-name").value = '';
    //         }
    //     }
    // }
    // canceldelete_popup(){
    //     document.querySelector(".favouriteNames-overlay").style.display = "block";
    //     document.querySelector(".delete-overlay").style.display = "none";
    //     document.getElementsByTagName('body')[0].style.overflow = "auto";
    // }
    
     render() {
        var headers = 'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken+',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop;
        var _backLink = this.state.backLink;
        
         var items = [];
         function numberCount(count){
              if (count != 0) {
                    return(
                        <span className="left nameCounts M14_42">{`${count} Names`}</span>   
                    )
              }
         }
         if(this.state.collectionList != "Records Not Found" && this.state.collectionList.length > 0){
            [].forEach.call(this.state.collectionList, function(value, key){
                items.push(
                    <li key={key} id={value.coll_id}>
                        <div className="collection_name left">
                            <a href={service.getRedirectUrl("/baby-names/favorite-baby-names/" + value.coll_id + "/amp/")}>
                                <span className="left listName R14_61">{value.coll_name}</span>
                                {numberCount(value.count)}
                            </a>
                        </div>
                        <html dangerouslySetInnerHTML={{ __html:`<span class="right icon editDeleteIcon" data-icon-font="&#xe002;" tabIndex="0" role="button" on="tap:edit_${value.coll_id}.toggleVisibility"></span>
                        
                         <div class="editOptions right" id=edit_${value.coll_id} hidden>
                            <span class="editcollection" data-icon-font="H" data-name="${value.coll_name}" tabIndex="0" role="button" on="tap:update-overlay.show,edit_${value.coll_id}.hide,AMP.setState({collectionId : '${value.coll_id}',selectColleName:'${value.coll_name}'})"><span class="R15_42 left editOptions-text">Edit</span></span>

                            <span class="deletecollection" data-id=${value.coll_id} data-icon-font="&#xe013;" tabIndex="0" role="button" on="tap:delete-overlay.show,edit_${value.coll_id}.hide,AMP.setState({collectionId : '${value.coll_id}',selectColleName:'${value.coll_name}'})"><span class="R15_42 left editOptions-text">Delete</span></span>
                            
                            <span class="crossbutton" data-icon-font="C" tabIndex="0" role="button" on="tap:edit_${value.coll_id}.hide"><span class="R15_42 left editOptions-text">Close</span></span>
                        </div>`
                        }}></html>
                        
                    </li>
                );
            })
        }

        // console.log(items.length)
        return (
            <main className="baby-names-main main-container">
                <div className="data-container">
               
                <meta name="atdlayout" content="babynames_ap" />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <a href={service.getRedirectUrl("/amp/")} className="R11_9e">Home</a>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <a href={service.getRedirectUrl("/baby-names/amp/")} className="R11_9e" target="_self">Baby Names</a>
                    </div>
                    <h1 className="B24_00">My Favourite Baby Names</h1>
                </div>
                
                <div className="sub-container">
                    <div className="favorite_container left">
                        {/* <!--collection icon ends--> */}
                        <div className="favouriteNames-overlay left">
                            <div className="favNameListCont left">
                                <div className="favlist-block left">
                                    <div className="fav-name-heading">  
                                    {/* {service.getRedirectUrl(this.state._backURL)}                               */}
                                        <a href={service.getRedirectUrl(`/baby-names/amp/`)} className="left">
                                            <span className="icon left backtocollList" data-icon-font="s"></span>
                                        </a>
                                        <span className="M16_white left favnmcoll">Favourite Name Collection</span>
                                        <span className="create-ic right" role="button" tabIndex="0" on="tap:createnew-collection-overlay.show" onClick={() => this.createlistfromCollection()}>Create +</span>
                                    </div>
                                    {items.length > 0 ?
                                        <ul className="favNameList left" id="favNameList">
                                            {items}
                                        </ul>
                                        :
                                        <div className="norecord-overlay left">
                                            <div className="norecord_alert">
                                                <div className="M16_42">No collection list created yet.</div>
                                                <div className="R15_9e">Please create the one to shortlist the cute baby names.</div>                             
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        {/* <!--create new list --> */}
                        <div className="createnew-collection-overlay" id="createnew-collection-overlay" hidden>
                            <div className="createnew-collection">
                                <form method="post" id="postcollection" name="postcollection" action-xhr={`${global.hosturl}parenting/BabynamesAmp/postcollection`}  target="_top">
                                <input type="hidden" name="headerdata" value={headers} />
                                <input type="hidden" name="currentUrl" value={global.currentURL}/>

                                    <div className="success-msg" submit-success="">
                                        <template type="amp-mustache">
                                        Successfull!!!
                                        </template>
                                    </div>
                                    <div className="error-msg" submit-error="">
                                        <template type="amp-mustache">
                                        Error!, please try again.
                                        </template>
                                    </div>
                                    <div id="create_list_popup">
                                        <div className="selct-title M18_42">Create New Collection</div>
                                        <span className="M14_42">Collection Name</span>
                                        <input type="text" placeholder="Family's, Father, Mother" className="input-name" name="input-name" />    
                                        <span className="error_msg R11_red"></span>
                                        <div className="popup-btns right">
                                            <span className="cancel-popup M14_9e" tabIndex="0" role="button" on="tap:createnew-collection-overlay.hide" onClick={(e) => this.cancelCreate_popup(e)}>CANCEL</span>
                                            <label htmlFor="newCollection">
                                                {/* <input type="submit" id="newCollection" name="newCollection" value=""/> */}
                                                <button type="submit" name="newCollection" className="M14_pink dev_create_fromcollection" id="dev_cll_crt" tabIndex="0" role="button" on="tap:create_list_popup.hide">
                                                CREATE 
                                                </button>
                                            </label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <!--edit collection popup starts--> */}
                        <div className="update-overlay left" id="update-overlay" hidden>
                            <div className="update_collection">
                                <form method="post"  name="editcollection" id="editcollection" action-xhr={`${global.hosturl}parenting/BabynamesAmp/editcollection`} target="_top">
                                    <input type="hidden" name="headerdata" value={headers} />
                                    <input type="hidden" name="currentUrl" value={global.currentURL}/>
                                    <input type="hidden" name="collectionId" data-amp-bind-value="collectionId" />
                                        <div className="success-msg" submit-success="">
                                            <template type="amp-mustache">
                                            Successfull!!!
                                            </template>
                                        </div>
                                        <div className="error-msg" submit-error="">
                                            <template type="amp-mustache">
                                            Error!, please try again.
                                            </template>
                                        </div>
                                    <div className="edit_collection_block" id="edit_collection_block">
                                        <span className="selct-title M18_42">Edit Collection</span> 
                                        <html dangerouslySetInnerHTML={{ __html:'<input type="text" placeholder="Family `s, Father, Mother" class="collname_edit" name="collname_edit" [value]="selectColleName"/>'
                                        }}>
                                        </html>
                                        <span className="updatelist_error_msg R11_red"></span>
                                                
                                        <div className="popup-btns right">
                                            <span className="cancel-update-popup M14_9e" tabIndex="0" role="button" on={`tap:update-overlay.hide`}>CANCEL</span>
                                            <label htmlFor="updateCollection">
                                                <button type="submit" id="updateCollection" name="updateCollection" className="M14_pink update_edited" tabIndex="0" role="button" on="tap:edit_collection_block.hide">UPDATE</button>
                                            </label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <!--edit collection popup ends--> */}

                        {/* <!--delete list popup starts--> */}
                        <div className="delete-overlay left" id="delete-overlay" hidden>
                            <div className="delete_alert">
                                <div className="M16_42 sure_delete">Are you sure?</div>
                                <div className="R14_42">Would you like to delete the collection will also delete favourite names of the list</div>
                                <div className="popup-btns right">
                                    <form method="post" id="deletecollection" action-xhr={`${global.hosturl}parenting/BabynamesAmp/deletecollection`} encType="application/json">
                                        <input type="hidden" name="headerdata" value={headers} />
                                        <input type="hidden" name="currentUrl" value={global.currentURL}/>
                                        <input type="hidden" name="collectionId" id="collectionID" data-amp-bind-value="collectionId" />
                                        <span className="cancel-delete-popup M14_9e" tabIndex="0" role="button" on="tap:delete-overlay.hide" onClick={() => this.canceldelete_popup()}>CANCEL</span>
                                        <label htmlFor="delCollection">
                                            <input type="submit" id="delCollection" value=""/>
                                            <span className="M14_pink dev_coldelt" tabIndex="0" role="button" on="tap:delete-overlay.hide" onClick={(e) => this.deletecollection(e, this)} data-id="">DELETE</span>
                                        </label>
                                    </form>
                                </div>
                            </div>
                        </div>
                        {/* <!--delete list popup ends--> */}
                        <div className="name-added">
                            <div className="nm-add">
                                <span></span>
                            </div>
                        </div>
                        <div className="abuse-overlay" hidden>
                            <div className="abuse-popup">
                                <span className="R14_42"></span> 
                            </div>
                        </div>
                        
                    </div>
                </div>
                </div>
            </main>
        )
    }
}

export default CollectionListAmp



// WEBPACK FOOTER //
// src/shared/baby-names-amp/CollectionListAmp.js